import { Component } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-videodetail',
  templateUrl: './videodetail.component.html',
  styleUrls: ['./videodetail.component.scss']
})
export class VideodetailComponent {

  public GenderList:any=[];
  public Ids:any=localStorage.getItem('grw_content_id');
  public allmasterData:any={};
  public DetailData:any=[];
  public sliderArray:any=[];
  public stepArray:any=[];
  public ingredianList:any=[];
  public loading:boolean = false;
  public EquipmentArray:any = [];
  public otherSelection:any='';
  public m_otherSelection:any='';
  public ms_otherSelection:any='';
  public d_otherSelection:any='';
  public s_otherSelection:any='';
  public c_otherSelection:any='';
  public freechcek:boolean=false;
  public videoUrl:any='';
  public show:boolean=false;

  value: number = 1;
  options: Options = {
    showTicksValues: false,    
    showTicks: true,
    disabled:true,
    stepsArray: [
      {value: 0, legend: 'Low'},
      {value: 1250, legend: 'Medium'},
      {value: 2500, legend: 'High'}
    ],
  };

  constructor(public router: Router, public service: GlobalService) {
    this.allmasterData = getLocalJSON('grw_materData'); 
    this.GenderList=this.allmasterData.genders;  
    this.getDetail();
   }


  getDetail(){
    const url = "/single-post-detail?post_id="+this.Ids; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        var data:any =response.data[0];
        if((data.post_type == 1 || data.post_type == 2 || data.post_type == 3) && data.post_category == 1  ){
          this.sliderArray=
          [ {id:1,name:'Balance',text:'balance', value:data.balance},
            {id:2,name:'Flexibility',text:'flexibility', value:data.flexibility},
            {id:3,name:'Focus',text:'focus', value:data.focus},
            {id:4,name:'Strength',text:'strength', value:data.strength},
            {id:5,name:'Endurance',text:'endurance', value:data.endurance},
          ];  
          if(data.other_type.length != 0){
            data.type_other =data.other_type[0].content;
          }
          if(data.type.length != 0){
            data.type.filter((el:any)=>{
              if(el.childContent == true){
                self.otherSelection = el._id;
              }
            })
          }
        }
        if((data.post_type == 1 || data.post_type == 2 || data.post_type == 3)  && data.post_category == 2  ){
          if(data.post_type == 1){
            this.sliderArray=
            [ {id:1,name:'Calories',text:'balance', value:data.avg_calories},
            ];
          } 
          if(data.post_type == 2){
            this.sliderArray=
            [ {id:1,name:'Calories',text:'balance', value:data.calories},
            ];
          } 
          if(data.post_type == 3){
            this.sliderArray=
            [ {id:1,name:'Calories',text:'balance', value:data.avg_calories},
            ];
          }
         
          if(data.diet_other.length != 0){
            data.diet_other =data.diet_other[0].content;
          }  
          if(data.subcategory_other.length != 0){
            data.subcategory_other =data.subcategory_other[0].content;
          }
          if(data.diet.length != 0){
            data.diet.filter((el:any)=>{
              if(el.childContent == true){
                self.d_otherSelection = el._id;
              }
            })
          }
          if(data.sub_category.length != 0){
            data.sub_category.filter((el:any)=>{
              if(el.childContent == true){
                self.s_otherSelection = el._id;
              }
            })
          }
          // if(data.cooking_time.length != 0){
          //   data.cooking_time.filter((el:any)=>{
          //     if(el.childContent == true){
          //       self.c_otherSelection = el._id;
          //     }
          //   })
          // }
          // if(data.cooking_other.length != 0){
          //   data.cooking_other =data.cooking_other[0].content;
          // }
        }
          // if(data.album.length !=0){
          //   data.albumss = data.album[0]._id;  
          // } else {
          //   data.albumss='';       
          // } 
          

        if(data.post_type == 1  && data.post_category == 1  ){
          if(data.post_equipment_sets_reps.length != 0){
            var count=1;
            data.post_equipment_sets_reps.filter((el:any)=>{
              self.EquipmentArray.push({id: count,equipment: el.equipment,sets: el.sets,reps:el.reps});
              count=count+1;
            })           
          } else {
            self.EquipmentArray =[{id: 1,equipment: '',sets: '',reps:''}];
          }
      
        }
        if((data.post_type == 1 && data.post_category == 2 ) || data.post_type == 3 || data.post_type == 2){
          if(data.post_steps !=''){
            // var mm:any= response.data.post_steps.split(',');
            var count=1;  
            data.post_steps.filter((el:any)=>{
              self.stepArray.push({id :count,textdisabled: true,checkdisabled:false,text:el.steps})
              count=count+1;
            }) 
          }
      }

        if(((data.post_type == 1  || data.post_type == 2 || data.post_type == 3 ) && data.post_category == 2 ) ){
          if(data.ingredients !=''){
            var jj:any= data.ingredients.split(',');
            jj.filter((el:any)=>{
              self.ingredianList.push(el);              
            }) 
          }
        }

        if(data.post_type == 1){
          this.freechcek = data.is_content_free;   
        } 
        
        if((data.post_type == 2 || data.post_type == 3 ) && data.post_category == 1  ){
          if(data.post_equipment_sets_reps.length != 0){
            var count=1;
            data.post_equipment_sets_reps.filter((el:any)=>{
              self.EquipmentArray.push({id: count,equipment: el.equipment,sets: el.sets,reps:el.reps});
              count=count+1;
            })
          } else {
            self.EquipmentArray.push({id: 1,equipment: '',sets: '',reps:''});
          }
        }
        if(data.content !='' ){
          // if(data.post_type==1 || data.post_type==3){
          //   this.videoUrl = this.service.playerBase+data.content +'-9fdkfJgJ.html';
          //   //  data.dimensions[0].player_id+'.html'; 
          //   // this.videoUrl = this.service.playerBase+data.content +'-'+ data.dimensions[0].player_id+'.html';       
          // } else {
            this.videoUrl =data.content;
          // }
        }       
         
        if(data.medical_condition.length != 0){
          data.medical_condition.filter((el:any)=>{
            if(el.childContent == true){
              self.m_otherSelection = el._id;
            }
            if(el.subchildContent==true){
              self.ms_otherSelection =el._id;
            }
          })
        }
        if(data.medical_other.length != 0){
          data.medical_other =data.medical_other[0].content;
        }
        this.DetailData = data;
        this.show=true;
      }
    }), (error) => { this.loading =false; });
  }

}

